/** Matches items Excel template/export/import columns in master-tables.js */
export const ITEMS_MASTER_HEADERS = [
  'Item ID',
  'Item Code',
  'Phase',
  'Sub Phase',
  'Cost Type',
  'Unit',
  'Active (1/0)',
] as const;

export function formatItemActiveExportValue(isActive: unknown): string {
  return Number(isActive) === 1 ? '1' : '0';
}
